var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedicineCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.624 27.376C166.792 57.544 166.792 106.456 136.624 136.624C106.456 166.792 57.5443 166.792 27.3765 136.624C-2.79151 106.456 -2.79151 57.5438 27.3765 27.376C57.5445 -2.792 106.456 -2.792 136.624 27.376",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4757 105.57L78.1289 124.917L66.5156 113.303",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2501 59.3745H47.6667C40.5597 59.3745 34.7917 65.1425 34.7917 72.2495V142.084",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.75 59.3745H116.333C123.44 59.3745 129.208 65.1425 129.208 72.2495V142.084",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3513 71.0733H65.6573C60.4558 71.0733 56.25 66.8674 56.25 61.6745V57.0653C56.25 51.8723 60.4558 47.6665 65.6487 47.6665H98.3427C103.544 47.6665 107.75 51.8723 107.75 57.0653V61.6659C107.75 66.8674 103.544 71.0733 98.3513 71.0733V71.0733Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineCheck);
export default __webpack_public_path__ + "static/media/medicineCheck.bfab834a587dd67efcad2da426b1667d.svg";
export { ForwardRef as ReactComponent };